import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { loanSchemeDetailTable } from "assets/properties/properties";
import { formatAmount } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
import {
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
} from "@material-ui/core";

import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";      // Good for interest
// OR
import ShowChartIcon from "@material-ui/icons/ShowChart";
// OR
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
const useStyles = makeStyles((theme) => ({
  card: {
    margin: '24px 5% 0',
    borderRadius: 14,
    border: "1px solid #E8ECEF",
    background: "#fff",
    overflow: "hidden",
    width:'100%'
  },

  cardHeader: {
    padding: "22px 28px",
    display: "flex",
    alignItems: "center",
    gap: 18,
    borderBottom: "1px solid #ECECEC",
  },

  headerIcon: {
    width: 52,
    height: 52,
    borderRadius: 12,
    background: "#ECF9F1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#1AA15F",
  },

  title: {
    fontWeight: 700,
    fontSize: 20,
    color: "#102A43",
  },

  subtitle: {
    color: "#7B8794",
    marginTop: 3,
    fontSize: 14,
  },

  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",

    "@media(max-width:900px)": {
      gridTemplateColumns: "1fr",
    },
  },

  summaryItem: {
    display: "flex",
    alignItems: "center",
    padding: 12,
    borderBottom: "1px solid #ECECEC",
    borderRight: "1px solid #ECECEC",
    "@media(max-width:900px)": {
      borderRight: "none !important",
    },
  },

  iconCircle: {
    width: 52,
    height: 52,
    borderRadius: 12,
    background: "#F0FBF5",
    color: "#18A558",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 18,
  },

  label: {
    color: "#5F6C7B",
    fontSize: 15,
  },

  value: {
    fontWeight: 700,
    fontSize: 22,
    color: "#14213D",
    marginTop: 4,
  },

  tableHead: {
    background: "#EEF4FB",

    "& th": {
      fontWeight: 700,
      color: "#23395B",
      fontSize: 15,
    },
  },

  tableCell: {
    fontSize: 15,
    padding: "18px 20px",
    borderBottom: "1px solid #ECECEC",
  },

  totalRow: {
    background: "#EEF9F2",
    padding: "18px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 700,
    fontSize: 22,
    color: "#0A9A4A",
  },
}));

const LoanDetails = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const location = useLocation();
  const schemeCode = location.state?.loanScheme;
  const loanAmount = location.state?.loanAmount;
  // Retrieve loanNumber from state
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [actualLoanAmount, setActualLoanAmount] = useState("");
  const [totalInterest, setTotalInterest] = useState("");
  const [relationshipList, setRelationshipList] = useState([]);
  const [transferToBank, setTransferTobank] = useState("");
  const [rateOfIntereset, setRateOfInterest] = useState("");
  const [totalCharges, setTotalCharges] = useState("");
  const [totalGst, setTotalGst] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [loanChargesTableData, setLoanChargesTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [disaledFields, setDisabledFields] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(leadId, "flaljdfkjadjk");
  useEffect(() => {
    // if (leadId) {
    fetchLoanSummary();
    // }
  }, [leadId]);

  const fetchLoanSummary = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url:
        endpoint.GET_LOAN_PAYMENT_DETAILS_API +
        leadId +
        "/" +
        schemeCode +
        `?loanAmount=${loanAmount}`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.loanAmount) {
      setTransferTobank(result?.data?.netDisbursalAmount);
      setTotalCharges(result?.data?.totalCharges);
      setTotalGst(result?.data?.totalGst);
      parseLoanChargesData(result.data.loanSchemeCalculation);
      getUserLoanDetails();
    } else {
      toastUpdate("Error", result?.data?.user_description, true);
    }
  };
  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_LOAN_REPAYMENT_DETAILS_API + leadId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    console.log(result?.data, "API DATA");
    setTotalInterest(result?.data?.interestAmount);
    setRateOfInterest(result?.data?.interestRate);
    setActualLoanAmount(result?.data?.loanAmount);
  };
  const handleNext = () => {
    navigate("/journey/RepaymentScheduleDetails");
  };
const parseLoanChargesData = (data) => {
  const reportData = [];
console.log(data,"fsdkfsdhb")
data?.forEach((item, index) => {
  const gstAmount =
  Number(item.cgstAmount || 0) +
  Number(item.sgstAmount || 0) +
  Number(item.igstAmount || 0);
  
  console.log(data,gstAmount,"fsdkfsdhb11")
    reportData.push({
      id: index + 1,
      chargeType: toCamelCase(item.chargeType),
      adjustedAmount: formatAmount(item.adjustedAmount),
      adjustedAmountWithoutGst: formatAmount(item.adjustedAmountWithoutGst),
      gstAmount: formatAmount(gstAmount),
    });
  });

  setLoanChargesTableData(reportData);
};
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Loan Details"
          button1="Next"
          button1click={handleNext}
        />
      </Grid>
      <Paper className={classes.card} elevation={0}>
  <div className={classes.cardHeader}>
    <div className={classes.headerIcon}>
      <DescriptionOutlinedIcon />
    </div>

    <div>
      <Typography className={classes.title}>
        Loan Summary
      </Typography>

      <Typography className={classes.subtitle}>
        Overview of your loan and applicable charges
      </Typography>
    </div>
  </div>

  <div className={classes.summaryGrid}>

    <div className={classes.summaryItem}>
      <div>
        <Typography className={classes.label}>
          Loan Amount
        </Typography>

        <Typography className={classes.value}>
          {formatAmount(actualLoanAmount)}
        </Typography>
      </div>
    </div>
    <div className={classes.summaryItem}>
      <div>
        <Typography className={classes.label}>
          Rate of Interest
        </Typography>

        <Typography className={classes.value}>
          {rateOfIntereset}%
        </Typography>
      </div>
    </div>
    <div className={classes.summaryItem}>
      <div>
        <Typography className={classes.label}>
          Total Interest
        </Typography>

        <Typography className={classes.value}>
          {formatAmount(totalInterest)}
        </Typography>
      </div>
    </div>
     <div className={classes.summaryItem}>
      <div>
        <Typography className={classes.label}>
          Transfer To Bank
        </Typography>

        <Typography className={classes.value}>
          {formatAmount(transferToBank)}
        </Typography>
      </div>
    </div>
  </div>
</Paper>
      <Paper className={classes.card} elevation={0}>

  <div className={classes.cardHeader}>
    <div className={classes.headerIcon}>
      <ReceiptOutlinedIcon />
    </div>

    <div>
      <Typography className={classes.title}>
        Charge Breakdown
      </Typography>

      <Typography className={classes.subtitle}>
        Detailed breakup of total charges
      </Typography>
    </div>
  </div>

  <TableContainer>

    <Table>

      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell>Charge Type</TableCell>
          <TableCell align="right">Base Amount (₹)</TableCell>
          <TableCell align="right">GST Amount (₹)</TableCell>
          <TableCell align="right">Total Amount (₹)</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>

        {loanChargesTableData.map((row) => {
          return (
            <TableRow key={row.id}>

              <TableCell className={classes.tableCell}>
                {row.chargeType}
              </TableCell>

              <TableCell
                className={classes.tableCell}
                align="right"
              >
                {row.adjustedAmountWithoutGst}
              </TableCell>

              <TableCell
                className={classes.tableCell}
                align="right"
              >
                {row.gstAmount}
              </TableCell>

              <TableCell
                className={classes.tableCell}
                align="right"
              >
                {row.adjustedAmount}
              </TableCell>

            </TableRow>
          );
        })}

      </TableBody>

    </Table>

  </TableContainer>

  <Divider />

  <div className={classes.totalRow}>
    <span>Total Charges</span>
    <span>{formatAmount(totalCharges)}</span>
  </div>

</Paper>
      {/* <Grid container className={classes.footer}>
        <Button size="small">Cancel</Button>
      </Grid> */}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default LoanDetails;
